import React from "react";
import { Button } from "../../components/Button";
import { ArrowBackIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import './403.css';

export const Page403: React.FC = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        const ref = document.referrer;
        const sameOrigin = ref && new URL(ref).origin === window.location.origin;

        if (sameOrigin) {
            navigate(-1);
            return false
        }

        navigate("/");
    };

    return (
        <div className="page403Container">
            <img className="page403Amary" src="/assets/amary-wife_transparent.png" alt="DaKasa LTDA" />
            <h1 className="page403Title">Acesso Negado</h1>
            <p className="page403Description">Você não tem permissão para acessar esta página. Converse com os administradores da sua organização se você deveria acessar essa página.</p>
            <Button
            callback={handleGoBack}
            icon={<ArrowBackIos />}
            iconSlot="start"
            class="btn403Back"
            >
                Voltar
            </Button>
        </div>
    );
}